<template>
  <v-layout align-start>
    <v-flex>
      <v-toolbar flat color="transparent" class="mt-2">
        <v-toolbar-title>Buzon de Sugerencias</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-select
          v-model="filterStatus"
          :items="statusOptions"
          label="Estado"
          dense hide-details outlined clearable
          style="max-width: 180px"
          class="mr-3"
        ></v-select>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line hide-details
        ></v-text-field>
      </v-toolbar>

      <v-data-table
            no-data-text="Todavía no se recibieron sugerencias"
            loading-text="Cargando…"
        :headers="headers"
        :items="filteredFeedbacks"
        :search="search"
        class="elevation-1"
        :loading="loading"
        sort-by="createdAt"
        sort-desc
      >
        <template v-slot:item.category="{ item }">
          <v-chip small :color="categoryColor(item.category)" dark>{{ item.category }}</v-chip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip small :color="statusColor(item.status)" dark>{{ item.status }}</v-chip>
        </template>
        <template v-slot:item.createdAt="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>
        <template v-slot:item.message="{ item }">
          <span class="d-inline-block text-truncate" style="max-width: 300px;">{{ item.message }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="openDetail(item)" title="Ver / Responder">visibility</v-icon>
          <v-select
            v-model="item.status"
            :items="['PENDIENTE', 'LEIDO', 'RESPONDIDO', 'ARCHIVADO']"
            dense hide-details
            style="max-width: 140px; display: inline-flex;"
            @change="updateStatus(item)"
          ></v-select>
        </template>
      </v-data-table>

      <!-- Dialog detalle / responder -->
      <v-dialog v-model="dialogDetail" max-width="600">
        <v-card v-if="selected">
          <v-card-title>
            <v-chip small :color="categoryColor(selected.category)" dark class="mr-2">{{ selected.category }}</v-chip>
            Comentario de {{ selected.affiliateName || 'Anónimo' }}
          </v-card-title>
          <v-card-text>
            <p class="subtitle-2 grey--text">{{ selected.affiliateEmail }} — {{ formatDate(selected.createdAt) }}</p>
            <v-divider class="my-3"></v-divider>
            <p style="white-space: pre-wrap; font-size: 14px;">{{ selected.message }}</p>

            <v-divider class="my-3"></v-divider>
            <p class="subtitle-2 font-weight-bold">Respuesta del equipo:</p>
            <v-textarea
              v-model="replyText"
              outlined
              rows="3"
              placeholder="Escribi tu respuesta..."
              :disabled="replying"
            ></v-textarea>
            <p v-if="selected.adminReply && !replyText" class="caption grey--text">
              Respuesta actual: {{ selected.adminReply }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogDetail = false">Cerrar</v-btn>
            <v-btn color="primary" @click="sendReply" :loading="replying" :disabled="!replyText.trim()">
              Responder
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      feedbacks: [],
      loading: false,
      search: "",
      filterStatus: null,
      dialogDetail: false,
      selected: null,
      replyText: "",
      replying: false,
      headers: [
        { text: "Nombre", value: "affiliateName" },
        { text: "Categoria", value: "category" },
        { text: "Comentario", value: "message" },
        { text: "Estado", value: "status" },
        { text: "Fecha", value: "createdAt" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      statusOptions: ["PENDIENTE", "LEIDO", "RESPONDIDO", "ARCHIVADO"],
    };
  },
  computed: {
    filteredFeedbacks() {
      if (!this.filterStatus) return this.feedbacks;
      return this.feedbacks.filter(f => f.status === this.filterStatus);
    },
  },
  async created() {
    await this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { data } = await axios.get("site-feedback");
        this.feedbacks = data;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    openDetail(item) {
      this.selected = item;
      this.replyText = item.adminReply || "";
      this.dialogDetail = true;
    },
    async sendReply() {
      this.replying = true;
      try {
        await axios.patch(`site-feedback/${this.selected._id}/reply`, {
          adminReply: this.replyText,
        });
        this.selected.adminReply = this.replyText;
        this.selected.status = "RESPONDIDO";
        this.dialogDetail = false;
        await this.load();
      } catch (e) {
        alert("Error al responder");
      } finally {
        this.replying = false;
      }
    },
    async updateStatus(item) {
      try {
        await axios.patch(`site-feedback/${item._id}/status`, { status: item.status });
      } catch (e) {
        alert("Error al actualizar estado");
      }
    },
    formatDate(d) {
      if (!d) return "";
      return new Date(d).toLocaleString("es-UY", {
        day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
      });
    },
    categoryColor(c) {
      const m = { SUGERENCIA: "purple", MEJORA: "blue", ERROR: "red", OTRO: "grey" };
      return m[c] || "grey";
    },
    statusColor(s) {
      const m = { PENDIENTE: "orange", LEIDO: "blue", RESPONDIDO: "green", ARCHIVADO: "grey" };
      return m[s] || "grey";
    },
  },
};
</script>
